import { render } from "./BranchDonutCard.vue?vue&type=template&id=57913d14&scoped=true"
import script from "./BranchDonutCard.vue?vue&type=script&lang=js"
export * from "./BranchDonutCard.vue?vue&type=script&lang=js"

import "./BranchDonutCard.vue?vue&type=style&index=0&id=57913d14&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57913d14"]])

export default __exports__